
/**
 * Module dependencies.
 */

import { createAction } from 'redux-actions'

/**
 * Types.
 */

export const REQUEST_NOTIFICATIONS = 'REQUEST_NOTIFICATIONS'
export const RECEIVE_NOTIFICATIONS = 'RECEIVE_NOTIFICATIONS'

/**
 * Actions.
 */

const requestNotifications = createAction(REQUEST_NOTIFICATIONS)
const receiveNotifications = createAction(RECEIVE_NOTIFICATIONS)

export function fetchNotifications (slug) {
  return (dispatch) => {
    dispatch(requestNotifications({ slug }))

    // Pretend to be async
    setTimeout(() => {
      dispatch(receiveNotifications({ slug, data: window.segment.notifications }))
    }, 1)
  }
}



// WEBPACK FOOTER //
// ./actions/notifications.js